// extracted by mini-css-extract-plugin
export default {"tabLabel":"DiscoverPage_tabLabel__sLRpl","label":"DiscoverPage_label__8nU+-","selected":"DiscoverPage_selected__DU4ln","loaderWrapper":"DiscoverPage_loaderWrapper__GT+O2"};